
 import { apiCall } from './apiCall';
    
    
  export default function customerinfoApi() {
    return {
      getCustomerList: (data,token) => apiCall('/getCustomerList',data, token),
      getCustomerInfoById: (data,token) => apiCall('/getCustomerInfoById',data, token),
      updateCustomerInfo: (data,token) => apiCall('/updateCustomerInfo',data, token),
      deleteCustomerInfo: (data,token) => apiCall('/deleteCustomerInfo',data, token),
  
    };
  }
  
  